import type { WorkflowItem } from "@/api/models"

export type WorkflowSidebarGroups = {
  favorites: WorkflowItem[]
  company: WorkflowItem[]
  personal: WorkflowItem[]
  shared: WorkflowItem[]
}

export function mergeOwnedAndSharedWorkflows(
  ownedWorkflows: WorkflowItem[],
  sharedWorkflows: WorkflowItem[]
): WorkflowItem[] {
  const ownedIds = new Set(ownedWorkflows.map((workflow) => workflow.id))
  return [...ownedWorkflows, ...sharedWorkflows.filter((workflow) => !ownedIds.has(workflow.id))]
}

export function takeVisibleWorkflowsByPriority(
  maxCount: number,
  lists: WorkflowSidebarGroups
): WorkflowSidebarGroups {
  let remaining = maxCount
  const favorites = lists.favorites.slice(0, remaining)
  remaining -= favorites.length
  const company = lists.company.slice(0, remaining)
  remaining -= company.length
  const personal = lists.personal.slice(0, Math.max(0, remaining))
  remaining -= personal.length
  const shared = lists.shared.slice(0, Math.max(0, remaining))
  return { favorites, company, personal, shared }
}

export function canBulkDeleteWorkflow(workflow: Pick<WorkflowItem, "visibility">): boolean {
  return workflow.visibility !== "shared"
}

export function getBulkDeletableWorkflows(workflows: WorkflowItem[]): WorkflowItem[] {
  return workflows.filter(canBulkDeleteWorkflow)
}
